import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { SessionService } from 'src/app/shared/services/session.service';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { AddonService } from 'src/app/simulator-booking/services/addon.service';

@Component({
    selector: 'addon-edit-model',
    templateUrl: './addon-edit-model.component.html',
    styleUrl: './addon-edit-model.component.scss',
    standalone: false
})
export class AddonEditModelComponent extends BaseModalComponent implements OnInit {
  constructor(private sessionService: SessionService,
    private addonService: AddonService,
    public dialogRef: MatDialogRef<AddonEditModelComponent>) {
    super();
  }

  ngOnInit(): void {
    this.form.get('organizationId').setValue(this.sessionService.getUser().organizationId);
  }

  public form = new FormGroup({
    id: new FormControl('', {
      validators: Validators.required
    }),
    name: new FormControl('', {
      validators: Validators.required
    }),
    description: new FormControl('', {  
      validators: Validators.required
    }),
    price: new FormControl(0, {
      validators: Validators.required
    }),
    isActive: new FormControl(true, {
      validators: Validators.required
    }),
    organizationId: new FormControl('', {
      validators: Validators.required
    }),
  });

  submit({value, valid}){
    if(valid){
      this.isLoading = true;
      value.lastEditedBy = this.sessionService.getUserId();
      this.addonService.update(value.id, value).subscribe({
        next: (result) => {
          if(result !== null || result !== undefined){
            this.dialogRef.close("save");
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error(error);
          this.setError(error, this.form);
        },
        complete: () => this.isLoading = false
      });
    }
  }

}
